import React from "react"
import styled, { withTheme } from "styled-components"

const CheckContainer = styled.div`
  display: flex;
  align-items: center;
  width: ${props => props.width || "15px"};
  height: ${props => props.height || "11px"};
  ${props => props.margin ? `margin: ${props.margin};` : `margin-right: 7px;`};
  ${props => props.marginTop && `margin-top: ${props.marginTop};`};
`

const Check = ({ theme, color, ...props}) => (
  <CheckContainer {...props}>
    <svg height={props.height || "11px"} width={props.width || "15px"} viewBox="0 0 16 11">
      <path
        fill="none"
        fillRule="evenodd"
        stroke={theme.colors[color]}
        strokeLinecap="round"
        strokeWidth={props.strokeWidth || "1.25"}
        d="M1.462 5.658l4.525 4.526 9.261-9.26"
      />
    </svg>
  </CheckContainer>
)

Check.defaultProps = {
  color: "success"
}

export default withTheme(Check)



// WEBPACK FOOTER //
// ./assets/completion/images/Check.js